import { useOutletContext } from "react-router-dom";

export const useActiveCareUser = () => {
  return useOutletContext();
};
